import vehicles from './vehicles'

export default { vehicles }
